"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPeerConnection = exports.CommonManager = void 0;
const browser_1 = require("../utils/browser");
const CommandsManager_1 = __importDefault(require("../general/CommandsManager"));
const Command_1 = __importDefault(require("../general/Command"));
const messageBroker_1 = __importDefault(require("../general/messageBroker"));
const StreamManager_1 = __importDefault(require("../webrtc/StreamManager"));
const status_indicator_1 = require("../utils/status-indicator");
const notifications_1 = require("../utils/notifications");
const logger_1 = require("../utils/logger");
const MessageType_1 = __importDefault(require("../general/MessageType"));
const mediaDevices_1 = require("../webrtc/mediaDevices");
const websocket_1 = require("../general/websocket");
const ui_1 = require("../common/ui");
const mirror_webrtc_manager_1 = __importDefault(require("../webrtc/mirror-webrtc-manager"));
const p2p_webrtc_manager_1 = require("../webrtc/p2p-webrtc-manager");
const audioprocessor_1 = require("../webaudio/audioprocessor");
class CommonManager {
    constructor(product, role, name, publicKey, roomKey, setupRTC = true) {
        this.peerList = [];
        this.serverDisconnected = false;
        this.sessionEnded = false;
        this.uri = "";
        this.wsuri = "";
        this.useSFU = true;
        this.connectedToWS = false;
        this.setupRTC = true;
        this.browser = {
            browser: "chrome",
        };
        this.hasEchoCancellation = true;
        this.product = product;
        this.role = role;
        this.name = name;
        this.publicKey = publicKey;
        this.roomKey = roomKey;
        this.serverDisconnected = false;
        this.setupRTC = setupRTC;
        this.logger = new logger_1.Logger("CommonManager", true);
        if (product == "anywhere") {
            this.useSFU = false;
        }
        if (this.publicKey.length < 6) {
            this.logger.error("Public key must be at least 6 characters long", publicKey);
            return;
        }
        this.browser = {
            browser: "chrome",
        };
        this.peerList = [];
        let env = "dev";
        // if its in production"
        if (!location.host.includes("localhost:3000")) {
            env = "prod";
        }
        // if its in staging the url will always begin with "beta.*"
        if (location.host.includes("beta")) {
            env = "beta";
        }
        const wsURIs = {
            dev: `ws://localhost:9997/${product}/ws`,
            beta: `wss://beta.milan.mictap.com/${product}/ws`,
            prod: `wss://milan.mictap.com/${product}/ws`,
        };
        const URIs = {
            dev: "http://localhost:9997",
            beta: "https://beta.milan.mictap.com",
            prod: "https://milan.mictap.com",
        };
        this.uri = URIs[env];
        this.wsuri = wsURIs[env];
        this.messageTypes = {
            "session--joined-room": this.logger.log.bind(this),
            "session--login-success": this.LoginSuccess.bind(this),
            "session--login-error": this.LoginError.bind(this),
            "session--update-info-success": this.JoinRoom.bind(this),
            "status--you-got-kicked-out": ui_1.handleEndOfSession,
            "status--peer-disconnected": this.handlePeerDisconnected.bind(this),
            "status--peer-removed": this.handlePeerRemoved.bind(this),
            "status--peer-list": this.handlePeerListMT.bind(this),
        };
        this.setupCommands();
    }
    setupCommands() {
        // @Vital for Commands
        const commandMessage = new MessageType_1.default('command', (data) => {
            const handled = CommandsManager_1.default.handleCommand(data);
            if (handled === false)
                this.logger.error('UNHANDLED COMMAND', data);
        });
        messageBroker_1.default
            .registerMessageType(commandMessage);
        messageBroker_1.default.on('receivedUnhandledData', (data) => this.logger.error('UNHANDLED MESSAGE', (data)));
        // @Mirror and Anywhere
        const setAECCommand = new Command_1.default('set_aec', (data) => {
            this.hasEchoCancellation = data.args;
            (0, notifications_1.localNotify)(`AEC Mode is now ${this.hasEchoCancellation ? 'on' : 'off'}`);
            (0, mediaDevices_1.updateConstraints)();
        }, CommandsManager_1.default);
        // @Anywhere
        const setAudioCodecCommand = new Command_1.default('set_audio_codec', (data) => {
            var _a, _b;
            (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.setAudioCodec(data.args);
            (_b = this.rtc) === null || _b === void 0 ? void 0 : _b.sendOfferToPeer(data.from);
        }, CommandsManager_1.default);
        CommandsManager_1.default
            .registerCommand(setAECCommand)
            .registerCommand(setAudioCodecCommand)
            .registerNewCommand('play_soundbar', (data) => {
            const sounds = document.querySelectorAll(`#${data.args.sound.src}`);
            sounds.forEach((sound) => {
                sound.play();
            });
        });
    }
    setupStreams() {
        this.logger.error("Setup streams");
    }
    handlePeerDisconnected(data) {
        // UI
        getParticipantList().updatePeer({
            public_key: data.public_key,
            status: "disconnected",
        });
    }
    handlePeerRemoved(data) {
        const pk = data.body;
        this.logger.log("Handle peer removed", pk);
        // UI
        getParticipantList().removePeer(pk);
        for (let i = 0; i < this.peerList.length; i++) {
            if (this.peerList[i].public_key == pk) {
                this.peerList.splice(i, 1);
                return;
            }
        }
    }
    NewPeer(peer) {
        this.logger.log("New peer is", peer);
        this.peerList.push(peer);
        // UI
        getParticipantList().addNewPeer(peer);
    }
    UpdatePeer(peer) {
        if (peer.status == "disconnected") {
            this.handlePeerDisconnected(peer);
        }
        this.logger.log("Peer got updated", peer);
        // UI
        getParticipantList().updatePeer(peer);
        // Send room status
        this.sendRoomStatus(peer.public_key);
        let mobileDrawer = getMobileDrawerParticipantList();
        if (mobileDrawer) {
            mobileDrawer.updatePeer(peer);
        }
    }
    handlePeerListMT(data) {
        this.HandlePeerList(data.peers, data.wtbc_peers);
        if (this.rtc) {
            this.rtc.canCallPeers = true;
        }
    }
    HandlePeerList(peers, wtbc_peers) {
        // filter myself
        peers = peers.filter((p) => p.public_key != this.publicKey); // check if it is me
        // add peers to commandsManager
        CommandsManager_1.default.updateConnectedPeers(peers);
        peers.forEach((p) => {
            if (!this.peerList.some((peer) => peer.public_key == p.public_key)) {
                this.NewPeer(p);
            }
            else {
                // check if the user was updated
                for (let i = 0; i < this.peerList.length; i++) {
                    if (this.peerList[i].public_key == p.public_key) {
                        // check if the status is different
                        if (this.peerList[i].status != p.status) {
                            this.UpdatePeer(p);
                        }
                    }
                }
            }
        });
        wtbc_peers = wtbc_peers.filter((p) => p.public_key != this.publicKey); // check if it is me
        wtbc_peers.forEach((p) => {
            if (!this.peerList.some((peer) => peer.public_key == p.public_key)) {
                getParticipantList().addNewPeer(p);
                this.peerList.push(p);
            }
            else {
                getParticipantList().updatePeer(p);
            }
        });
    }
    sendRoomStatus(public_key) {
        if (this.role != "host")
            return;
        // Send room status to the connected peer
        this.logger.error("Not implemented - send room status", public_key);
    }
    Login() {
        // @ts-ignore
        let deviceToken = window.sessionToken; // this is set at random when the user loads the page
        if (deviceToken == null || deviceToken.length == 0) {
            // Generate a device token locally and then use it to login
            deviceToken = this.NewDevicetoken();
            // @ts-ignore: window
            window.sessionToken = deviceToken;
        }
        messageBroker_1.default.send({
            type: "login",
            participant_key: this.publicKey,
            device_token: deviceToken,
        });
    }
    NewDevicetoken() {
        // For now the token is just the time we connected, this should be an random crypto stuff
        let deviceToken = Date.now() + "";
        sessionStorage.setItem("mt_token", deviceToken);
        return deviceToken;
    }
    LoginSuccess(data) {
        this.logger.log("LOGIN SUCCESS", data);
        const st = localStorage.setItem("mt_st_" + this.publicKey, data.session);
        messageBroker_1.default.send({
            type: "session--update-info",
            name: this.name,
            role: this.role,
            public_key: this.publicKey,
            browser: this.browser.browser,
        });
    }
    LoginError(data) {
        this.logger.error("error logging in", data);
        if (data.error == "Kicked user attempting to log-in") {
            // handle that the current user was kicked
            // Stop whatever stream we have currently going on
            alert("You were disconnected. Reason: another person used the same link to connect to the session.");
            this.endSession();
        }
    }
    JoinRoom() {
        // create the New WebRTC manager
        messageBroker_1.default.send({
            type: "rtc--join-room",
            body: this.roomKey,
        });
    }
    setupMediaDevicesManager() {
        StreamManager_1.default.on("FINISHED_GETTING_STREAMS", () => {
            var _a;
            const newTracks = StreamManager_1.default.getTracks("talent/guest", this.role);
            // set the tracks in the mirror-webrtc-manager
            (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.SetRTCTracks(newTracks);
        });
        const browser = (0, browser_1.detectBrowser)(window);
        this.browser = browser;
        // Media devices
        const subscriber = (0, mediaDevices_1.setupMediaDevices)(browser, this.product, this.role);
        subscriber.on("NOTIFY", (message, type) => {
            (0, notifications_1.localNotify)(message, type);
        });
        // we need to call this method after setupMediaDevices, so that media dvices
        // knows our role
        if (this.role == "host" || this.role == "guest") {
            // Set the listeners on the appropiate places
            navigator.mediaDevices
                .enumerateDevices()
                .then((e) => {
                (0, mediaDevices_1.gotDevices)(e);
                if (this.role == "guest") {
                    setTimeout(() => {
                        const select = document.querySelector(".audioSource");
                        select.value = "default";
                        select.dispatchEvent(new Event("change"));
                    }, 1000);
                }
            })
                .catch(handleError);
        }
        else {
            StreamManager_1.default.refresh();
        }
        // this event is fired whenever the value of a selector changes,
        // when it does we should set up the new constraints on the manager
        // and tell the RTC to refresh the streams (and call the users)
        subscriber.on("GET_USER_MEDIA", (constraints) => {
            Object.keys(constraints).forEach((key) => {
                StreamManager_1.default.setConstraints(key, constraints[key]);
            });
            // TODO: tell the RTC to refresh the user media why?
            StreamManager_1.default.refresh();
        });
        subscriber.on("SEND_SESSION_INFO", () => {
            this.sendSessionInfo({});
        });
    }
    setupWebSocketConnection(wsuri, onConnected) {
        let connectionTask = (0, status_indicator_1.addTask)({
            id: "ws_connection",
            determinate: false,
            message: "Connecting to server",
        });
        const sock = (0, websocket_1.setupWebSocket)(wsuri);
        if (sock == null) {
            this.logger.error("Socket was not setup correctly");
        }
        sock.on("connected", () => {
            this.serverDisconnected = false;
            this.logger.log("Connected to websocket");
            messageBroker_1.default.update({
                name: this.name,
                role: this.role,
                room: this.roomKey,
                participantKey: this.publicKey,
                socket: sock,
            });
            this.connectedToWS = true;
            connectionTask.done();
            this.sock = sock;
            onConnected();
        });
        sock.on("disconnected", () => {
            this.logger.error("Disconnected from websocket");
            this.serverDisconnected = true;
            if (connectionTask && connectionTask.valid()) {
                // connectionTask.error(); // set connection task as error
            }
            else {
                // Show UI reconnecting to SFU
                connectionTask = (0, status_indicator_1.addTask)({
                    id: "ws_connection",
                    determinate: false,
                    message: "Reestablishing connection",
                });
            }
        });
        sock.on("websocketMessage", (data) => {
            // this.logger.log("[WebSocket Message]", data);
            const fn = this.messageTypes[data.type];
            if (fn != undefined) {
                fn(data);
                return;
            }
            messageBroker_1.default.handleReceiveData(data);
        });
        return sock;
    }
    setupUI() {
        this.logger.error("not implemented");
    }
    beforeUnloadHook(e) {
        // disabling the before unload listener
        return;
        // Cancel the event
        e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = "";
    }
    // initializes components and establishes a comunication path between them
    initialSetup() {
        var _a;
        // 1. Setup web socket
        this.setupWebSocketConnection(this.wsuri, () => {
            // on Connected
            window.setTimeout(() => {
                // Lets log in when setup is done
                this.Login();
            }, 1000);
        });
        // 2. Setup Streams
        this.setupStreams();
        // 3. Setup UI
        (0, audioprocessor_1.startWebAudio)();
        this.setupUI();
        // This is needed for:
        // - to check whether to listen to input changes or not in media devices
        // - It may be used for something else
        window.addEventListener("beforeunload", (e) => {
            this.beforeUnloadHook(e);
        });
        if (this.setupRTC) {
            // @ts-ignore
            if (window.startSoundMeterContext) {
                // @ts-ignore
                window.startSoundMeterContext();
            }
            if (this.useSFU) {
                this.rtc = this.getNewSFUWebRTCManager();
            }
            else {
                this.rtc = this.getNewP2PWebRTCManager();
            }
            this.setupMediaDevicesManager();
            // handle message types
            Object.keys((_a = this.rtc) === null || _a === void 0 ? void 0 : _a.MessageTypes).forEach((mt) => {
                var _a;
                messageBroker_1.default.registerNewMessageType(mt, (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.MessageTypes[mt]);
            });
        }
        if (this.role !== "host")
            (0, ui_1.playApollo)();
        let timeGone = Date.now();
        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                this.logger.log("Pausing new connections until user returns");
                timeGone = Date.now();
            }
            else {
                this.logger.log("Resuming new connections, if there are any");
                this.logger.log("Time gone", (Date.now() - timeGone) / 1000, "s");
            }
        });
        this.setupEndSession();
        CommandsManager_1.default.registerNewCommand("active_until", (data) => {
            let timeRemaining = data.args.activeUntil;
            window.clearInterval(this.activeUntilInterval);
            this.activeUntilInterval = window.setInterval(() => {
                timeRemaining -= 1000; // parseInt(timeRemaining * 1000) - new Date();
                if (timeRemaining <= 0) {
                    window.clearInterval(this.activeUntilInterval);
                    alert("Your session has ended");
                    this.endSession();
                }
            }, 1000);
        });
    }
    getNewSFUWebRTCManager() {
        return new mirror_webrtc_manager_1.default(
        // sender function
        (data) => {
            data.recipient = "default-room";
            messageBroker_1.default.send(data);
        }, 
        // on new remote track
        (newTrack) => {
            this.handleSFUTrack(newTrack);
        }, 
        // on connected
        () => {
            (0, ui_1.handleUIOnRTCConnected)();
            (0, ui_1.pauseAndHideApollo)();
        }, this.onDisconnected.bind(this), this.sdpTransformer.bind(this));
    }
    getNewP2PWebRTCManager() {
        return new p2p_webrtc_manager_1.P2PWebRTCManager((data) => {
            messageBroker_1.default.send(data);
        }, (newTrack, sender) => {
            let peerRole = "";
            this.peerList.forEach((p) => {
                if (p.public_key == sender) {
                    peerRole = p.role;
                }
            });
            if (peerRole == "") {
                this.logger.error("Couldn't find role for peer");
            }
            this.logger.log("New remote track", newTrack, peerRole, sender);
            this.handleP2PTrack(newTrack, peerRole, sender);
        }, 
        // onConnected
        () => {
            (0, ui_1.handleUIOnRTCConnected)();
            (0, ui_1.pauseAndHideApollo)();
        }, this.onDisconnected.bind(this), 
        // track filtering function
        (track, trackReceiverPublicKey) => {
            let peerRole = "";
            this.peerList.forEach((p) => {
                if (p.public_key == trackReceiverPublicKey) {
                    peerRole = p.role;
                }
            });
            if (peerRole == "") {
                this.logger.error("Couldn't find role for peer");
            }
            if (this.role != "host") {
                return track.label == "LOCAL_AUDIO";
            }
            if (peerRole == "talent") {
                return track.label == "TALENT_AUDIO";
            }
            if (peerRole == "guest") {
                return track.label == "LOCAL_AUDIO";
            }
        }, this.sdpTransformer.bind(this));
    }
    handleP2PTrack({ streams, track }, peerRole, peerKey) {
        let label = "AUDIO"; // we dont care for the label in P2P
        // Its always audio in P2P
        if (streams.length == 0) {
            this.logger.error("No streams in track", track);
            let newStream = new MediaStream([track]);
            this.handleAudioStream(newStream, peerRole, peerKey, label);
        }
        else {
            this.handleAudioStream(streams[0], peerRole, peerKey, label);
        }
        (0, mediaDevices_1.changeAudioDestination)();
    }
    onDisconnected(state) {
        var _a;
        if (this.useSFU) {
            // on disconnection attempt to reconnect only if the session hasn't ended
            if (this.sessionEnded || this.serverDisconnected)
                return;
            (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.AddAndCallPeer();
        }
        else {
            // on disconnection attempt to reconnect to all the peers?
            this.logger.error("Got disconnected, should reconnect with everyone");
        }
    }
    handleSFUTrack({ streams, track }) {
        let [peerRole, peerKey, kind, label] = streams[0].id.split("__");
        this.logger.log(streams, track);
        if (track.kind == "video") {
            this.handleVideoStream(streams[0], peerRole, peerKey, label);
        }
        if (track.kind == "audio") {
            this.handleAudioStream(streams[0], peerRole, peerKey, label);
            (0, mediaDevices_1.changeAudioDestination)();
        }
    }
    handleVideoStream(stream, peerRole, id, label) {
        this.logger.log("Setting video stream?", stream, peerRole, id, label);
        const newVideo = document.createElement("video");
        newVideo.autoplay = true;
        newVideo.controls = true;
        newVideo.playsInline = true;
        newVideo.srcObject = stream;
        document.body.appendChild(newVideo);
    }
    handleAudioStream(stream, peerRole, id, label) {
        const newAudio = document.createElement("audio");
        newAudio.setAttribute("data-id", id);
        newAudio.setAttribute("data-label", label);
        newAudio.setAttribute("data-role", peerRole);
        newAudio.setAttribute("autoplay", "autoplay");
        newAudio.setAttribute("playsinline", "playsinline");
        newAudio.srcObject = stream;
        // newAudio.setAttribute('controls', 'controls');
        document.body.appendChild(newAudio);
    }
    handleVideoStreamRemoved(peerRole, id, label) {
        this.logger.log("Stream removed, this is a stub fn", peerRole, id, label);
    }
    setupEndSession() {
        let hangupButton = document.querySelector("#hangup-button");
        hangupButton === null || hangupButton === void 0 ? void 0 : hangupButton.classList.remove("hidden");
        hangupButton === null || hangupButton === void 0 ? void 0 : hangupButton.addEventListener("click", () => {
            if (confirm("Are you sure you want to disconnect?")) {
                this.endSession("USER");
            }
        });
        CommandsManager_1.default.registerNewCommand("end_session", this.endSession.bind(this));
        const endOfSessionButton = document.querySelector("#endOfSessionButton");
        if (endOfSessionButton) {
            endOfSessionButton.addEventListener("click", () => {
                this.endSession("USER");
            });
        }
    }
    endSession(reason = null) {
        messageBroker_1.default.sendMessage({ role: this.role, message: "I am leaving" }, "bye");
        (0, ui_1.handleEndOfSession)();
        window.clearInterval(this.activeUntilInterval);
        this.activeUntilInterval = null;
        this.sessionEnded = true;
        // NOTE: If RTC streams are live handle those disconnections
    }
    // this is a stub fn
    sdpTransformer(sdp, type, participantKey) {
        return sdp;
    }
    sendSessionInfo(params) {
        var _a, _b;
        let isRecording = false;
        if (params) {
            isRecording = params.isRecording;
        }
        // @ts-ignore: window
        let uploadSpeed = (_a = window.uploadSpeed) !== null && _a !== void 0 ? _a : 0;
        // @ts-ignore: window
        let downloadSpeed = (_b = window.downloadSpeed) !== null && _b !== void 0 ? _b : 0;
        const data = {
            sender: this.publicKey,
            uploadSpeed,
            downloadSpeed,
            isRecording,
        };
        messageBroker_1.default.sendMessage(data, 'session_info');
    }
}
exports.CommonManager = CommonManager;
function getParticipantList() {
    // @ts-ignore
    if (vm.$refs.orchestrator)
        return vm.$refs.orchestrator.$refs.participantList;
    // @ts-ignore
    if (vm.$refs.participantList)
        return vm.$refs.participantList;
    return {};
}
function getMobileDrawerParticipantList() {
    // @ts-ignore
    if (vm.$refs.orchestrator)
        return vm.$refs.orchestrator.$refs.participantList;
    // @ts-ignore
    if (vm.$refs.participantList)
        return vm.$refs.participantList;
    return null;
}
function handleError(error) {
    const errorContainerEl = document.querySelector("#error-container");
    errorContainerEl === null || errorContainerEl === void 0 ? void 0 : errorContainerEl.classList.remove("hidden");
    const errorMessage = `There was an error: ${error}`;
    const spanErrorMsgEl = document.querySelector("span#errorMsg");
    if (spanErrorMsgEl) {
        spanErrorMsgEl.innerHTML = errorMessage;
    }
    this.logger.error(error);
}
/// /////////////////////////////////////
// MESSAGE TYPES
/// ////////////////////////////////////
messageBroker_1.default.registerNewMessageType('session_info', (data) => {
    const peer = getPeerConnection(data.message.sender);
    if (peer)
        peer.component.updatePeerInfo(data);
});
messageBroker_1.default.registerNewMessageType('bye', (data) => {
    (0, notifications_1.localNotify)("Peer disconnected", 'error');
    if (data.message.role == 'host') {
        // tell the server to disconnect the peer
        messageBroker_1.default.send({
            to: "server",
            type: "disconnect-peer",
            body: window.participant_key + "" // to ensure it is a string
        });
    }
    this.endSession();
    // handleRemoteHangup(data.from);
});
function handleRemoteHangup(id) {
    (0, ui_1.handleVideoStreamRemoved)(id); // @Presenter only
    // TODO: Delete pointer for Presenters
    // if (product == 'presenter') { // removes pointer from peers if kicked by the host
    //   sendAllCommand('delete_pointer', id);
    // }
    // handle remote hangup UI wise.
    return getParticipantListComponent().handleRemoteHangup(id);
}
function getParticipantListComponent() {
    // @ts-ignore: window
    const vm = window.vm;
    if (vm === undefined)
        return {};
    if (vm.$refs.orchestrator)
        return vm.$refs.orchestrator.$refs.participantList;
    if (vm.$refs.participantList)
        return vm.$refs.participantList;
    return {};
}
function getPeerConnection(id) {
    const participantList = getParticipantListComponent();
    if (!participantList)
        return null;
    return participantList.getPeerConnection(id);
}
exports.getPeerConnection = getPeerConnection;
